export default {
  dataIterator: {
    rowsPerPageText: 'Елементів на сторінці:',
    rowsPerPageAll: 'Всі',
    pageText: '{0}-{1} з {2}',
    noResultsText: 'В результаті пошуку нічого не знайдено',
    nextPage: 'Наступна сторінка',
    prevPage: 'Попередня сторінка'
  },
  dataTable: {
    rowsPerPageText: 'Рядків на сторінці:'
  },
  noDataText: 'Немає даних для відображення'
}
